import React, { useMemo, useState } from "react";

import PropTypes from "prop-types";

const ClientContext = React.createContext();

export const ClientContextProvider = (props) => {
    const [activeInactiveState, setActiveInactiveState] = useState(true);

    const contextValue = useMemo(() => {
        return {
            activeInactiveState,
            setActiveInactiveState,
        };
    }, [activeInactiveState, setActiveInactiveState]);

    return (
        <ClientContext.Provider value={contextValue}>
            {props.children}
        </ClientContext.Provider>
    );
};

ClientContextProvider.propTypes = {
    children: PropTypes.node,
};

export default ClientContext;